"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var keycode = require("keycode");
var classes_1 = require("../lib/classes");
var ItemWrapper = /** @class */ (function (_super) {
    __extends(ItemWrapper, _super);
    function ItemWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            _this.props.onToggle(_this.props.id);
        };
        _this.handleKeydown = function (e) {
            var _a = _this.props, id = _a.id, onFocusShift = _a.onFocusShift;
            var key = keycode(e.which);
            if (key === 'up' || key === 'page up') {
                e.preventDefault();
                onFocusShift('backwards', id);
            }
            else if (key === 'down' || key === 'page down') {
                e.preventDefault();
                onFocusShift('forwards', id);
            }
            else if (key === 'home') {
                onFocusShift('start', id);
            }
            else if (key === 'end') {
                onFocusShift('end', id);
            }
        };
        return _this;
    }
    ItemWrapper.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, title = _b.title, children = _b.children, _c = _b.className, className = _c === void 0 ? '' : _c, open = _b.open, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onToggle = _b.onToggle, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onFocusShift = _b.onFocusShift, buttonRef = _b.buttonRef, classPrefix = _b.classPrefix, props = __rest(_b, ["id", "title", "children", "className", "open", "onToggle", "onFocusShift", "buttonRef", "classPrefix"]);
        var cx = classes_1.default((_a = {},
            _a[classPrefix + "-item"] = true,
            _a[classPrefix + "-item-open"] = open,
            _a[className] = !!className,
            _a));
        var contentId = id + "_content";
        var titleId = id + "_title";
        return (React.createElement("div", __assign({ className: cx }, props),
            React.createElement("div", { className: classPrefix + "-item-title" },
                React.createElement("button", { "aria-expanded": open, className: classPrefix + "-item-trigger", "aria-controls": contentId, id: titleId, onKeyDown: this.handleKeydown, onClick: this.handleClick, ref: buttonRef, type: "button" },
                    title,
                    React.createElement("span", { className: classPrefix + "-item-icon", "aria-hidden": true }))),
            React.createElement("div", { id: contentId, role: "region", "aria-labelledby": titleId, className: classPrefix + "-item-content", hidden: !open }, children)));
    };
    ItemWrapper.displayName = 'AccordionItemWrapper';
    return ItemWrapper;
}(React.Component));
exports.default = ItemWrapper;
//# sourceMappingURL=ItemWrapper.js.map